var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"auxcard el-row"},[_c('iframe',{staticClass:"auxmode-iframe",attrs:{"src":"https://dashboard.auxmode.com/AuxMode_Dashboard/dashboard-clients.jsp","frameborder":"0","scrolling":"yes"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }